import type { GlobalNotificationPlacement, GlobalNotificationWithTree } from '../types/globalNotifications'

export interface GlobalNotificationFilter {
    placement: GlobalNotificationPlacement
    path: string
    isStaff: boolean
    dismissedIds: ReadonlySet<number>
}

export function filterGlobalNotifications(
    notifications: readonly GlobalNotificationWithTree[],
    { placement, path, isStaff, dismissedIds }: GlobalNotificationFilter,
): GlobalNotificationWithTree[] {
    return notifications.filter((notification) => {
        if (notification.placement !== placement) return false
        if (dismissedIds.has(notification.id)) return false
        if (notification.staff_only && !isStaff) return false
        let prefix = notification.url_path_prefix?.replace(/\/+$/, '')
        if (prefix && !prefix.startsWith('/')) prefix = `/${prefix}`
        if (prefix && path !== prefix && !path.startsWith(`${prefix}/`)) return false
        return true
    })
}
